import { render, staticRenderFns } from "./RegionInput.vue?vue&type=template&id=12593c82"
import script from "./RegionInput.vue?vue&type=script&lang=js"
export * from "./RegionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports